import './index.scss';
import Initializer from 'lib/initializer';
import EntryFormatter from '../entry_formatter';
import $ from 'jquery';

Initializer.registerComponent('site/related_list', function(element) {
  EntryFormatter.formatVideoEmbeds($(element));
});
